// extracted by mini-css-extract-plugin
export default {"component":"oprJvqr5PSV35Z4MYrKO"};